var map = {
	"./background-branch-detail.svg": "./src/assets/backgrounds/background-branch-detail.svg",
	"./background-customer.svg": "./src/assets/backgrounds/background-customer.svg",
	"./background-document-detail.svg": "./src/assets/backgrounds/background-document-detail.svg",
	"./background-document.svg": "./src/assets/backgrounds/background-document.svg",
	"./background-fl-detail.svg": "./src/assets/backgrounds/background-fl-detail.svg",
	"./background-panel-hello.svg": "./src/assets/backgrounds/background-panel-hello.svg",
	"./background-pos-detail.svg": "./src/assets/backgrounds/background-pos-detail.svg",
	"./background-supplier.svg": "./src/assets/backgrounds/background-supplier.svg",
	"./modal-branch.svg": "./src/assets/backgrounds/modal-branch.svg",
	"./modal-cl-accept.svg": "./src/assets/backgrounds/modal-cl-accept.svg",
	"./modal-cl-claim.svg": "./src/assets/backgrounds/modal-cl-claim.svg",
	"./modal-document-clone.svg": "./src/assets/backgrounds/modal-document-clone.svg",
	"./modal-document-confirm.svg": "./src/assets/backgrounds/modal-document-confirm.svg",
	"./modal-document-create-fl.svg": "./src/assets/backgrounds/modal-document-create-fl.svg",
	"./modal-document-create-success.svg": "./src/assets/backgrounds/modal-document-create-success.svg",
	"./modal-document-error-fl.svg": "./src/assets/backgrounds/modal-document-error-fl.svg",
	"./modal-document-null.svg": "./src/assets/backgrounds/modal-document-null.svg",
	"./modal-el-lock.svg": "./src/assets/backgrounds/modal-el-lock.svg",
	"./modal-export-fl.svg": "./src/assets/backgrounds/modal-export-fl.svg",
	"./modal-folios-upload.svg": "./src/assets/backgrounds/modal-folios-upload.svg",
	"./modal-member.svg": "./src/assets/backgrounds/modal-member.svg",
	"./modal-mode.svg": "./src/assets/backgrounds/modal-mode.svg",
	"./modal-numbering.svg": "./src/assets/backgrounds/modal-numbering.svg",
	"./modal-purchase-null.svg": "./src/assets/backgrounds/modal-purchase-null.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/backgrounds sync recursive ^\\.\\/.*\\.svg$";